import { Modal } from '@chronosphereio/chrono-ui';
import { useDeletePanelDialog } from '../../context';

export const DeletePanelDialog = () => {
  const { deletePanelDialog, closeDeletePanelDialog, deletePanel } = useDeletePanelDialog();

  const handleDelete = () => {
    if (!deletePanelDialog) {
      return;
    }
    deletePanel(deletePanelDialog.panelGroupItemId);
    closeDeletePanelDialog();
  };

  const panelName = deletePanelDialog?.panelName;
  const formattedPanelName = panelName ? `"${panelName}"` : 'this panel';

  return (
    <Modal
      open={deletePanelDialog !== undefined}
      title="Delete panel"
      onClose={closeDeletePanelDialog}
      onPrimaryButtonClick={handleDelete}
      primaryButtonText="Delete"
      primaryButtonDanger
      size="small"
    >
      Are you sure you want to delete {formattedPanelName}?
    </Modal>
  );
};
